import { RootState } from 'redux/store';

export const isLoggedInSelector = (state: RootState) => state.auth.isLoggedIn;
export const isLoginLoadingSelector = (state: RootState) => state.auth.isLoading;
